import {inject} from '@angular/core';
import {WcbUserService} from './user.service';
import {ActivatedRouteSnapshot} from "@angular/router";

export const wcbAuthorizationGuard = (route: ActivatedRouteSnapshot) => {
    const userService = inject(WcbUserService);
    return userService.isAuthorized(route);
}
